import React, { Component } from "react";
import classNames from 'classnames';
import PropTypes from 'prop-types';

const propTypes = {
	box: PropTypes.string,
	className: PropTypes.string,
	mockup: PropTypes.bool,
}

const defaultProps = {
	box: 'a',
	className: null,
	mockup: true,
}

class SitePreview extends Component {
	wrapperClasses = classNames(
		'jiffy--site-preview',
		this.props.className
	);

	render() {
		let showMockup = this.props.mockup;

		return (
			<div className={this.wrapperClasses}>
				{showMockup &&
					<div className="jiffy--site-preview-navbar"></div>
				}
				<div className="jiffy--site-preview-main">
					{showMockup &&
						<div className="jiffy--site-preview-sidebar"></div>
					}
					<div className="jiffy--site-preview-content">
						<div className="jiffy--preview__box--a">{(this.props.box === 'a' || !showMockup) && this.props.children}</div>
						{(showMockup && this.props.box !== 'a') &&
							<React.Fragment>
								<div className="jiffy--preview__box--b">{this.props.box === 'b' && this.props.children}</div>
								<div className="jiffy--preview__box--c">{this.props.box === 'c' && this.props.children}</div>
							</React.Fragment>
						}
					</div>
				</div>
			</div>
		)
	}
}

SitePreview.propTypes = propTypes;
SitePreview.defaultProps = defaultProps;

export { SitePreview };